import { createAction, props } from '@ngrx/store';
import {
    CandidateAvailabilityDate,
    MultiBundleStatus,
    ScheduleOrientation,
    ScheduleOrientationPresetDate
} from 'src/app/compliance/models/schedule-orientation.model';
import { FetchArgs, PagingToken } from 'src/app/shared/models/core';
import { ScheduleOrientationSessionType } from 'src/app/compliance/models/schedule-orientation-session-type';
import { AddOrientationSession, UpdateOrientationDay } from 'src/app/compliance/models/add-orientation-session.model';

export const loadScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation API',
    props<{ contractId: number }>()
);

export const loadScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const loadScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Fail',
    props<{ error: any }>()
);

export const loadScheduleOrientationSessions = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Sessions API',
    props<{ contractId: number; args: FetchArgs }>()
);

export const loadScheduleOrientationSessionsSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Sessions Success',
    props<{ scheduleOrientationSessions: PagingToken<ScheduleOrientation[]> }>()
);

export const loadScheduleOrientationSessionsFail = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Sessions Fail',
    props<{ error: any }>()
);

export const loadActionRequiredOrientationSessionsCount = createAction(
    '[SCHEDULE ORIENTATION] Load Action Requireqd Orientation Sessions Count API',
    props<{ contractId: number }>()
);

export const loadActionRequiredOrientationSessionsCountSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Action Requireqd Orientation Sessions Count Success',
    props<{ count: number }>()
);

export const loadActionRequiredOrientationSessionsCountFail = createAction(
    '[SCHEDULE ORIENTATION] Load Action Requireqd Orientation Sessions Count Fail',
    props<{ error: any }>()
);

export const loadScheduleOrientationSessionTypes = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Session Types API'
);

export const loadScheduleOrientationSessionTypesSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Session Types Success',
    props<{ scheduleOrientationSessionTypes: ScheduleOrientationSessionType[] }>()
);

export const loadScheduleOrientationSessionTypesFail = createAction(
    '[SCHEDULE ORIENTATION] Load Schedule Orientation Session Types Fail',
    props<{ error: any }>()
);

export const setScheduleOrientationDateForCandidate = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Date For Candidate API',
    props<{ scheduleOrientationId: number; contractId: number; dateId: number }>()
);

export const setScheduleOrientationDateForCandidateSuccess = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Date For Candidate Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const setScheduleOrientationDateForCandidateFail = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Date For Candidate Fail',
    props<{ error: any }>()
);

export const addScheduleOrientationDateForCandidate = createAction(
    '[SCHEDULE ORIENTATION] Add Schedule Orientation Date For Candidate API',
    props<{ scheduleOrientationId: number; contractId: number; date: Date | string }>()
);

export const addScheduleOrientationDateForCandidateSuccess = createAction(
    '[SCHEDULE ORIENTATION] Add Schedule Orientation Date For Candidate Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const addScheduleOrientationDateForCandidateFail = createAction(
    '[SCHEDULE ORIENTATION] Add Schedule Orientation Date For Candidate Fail',
    props<{ error: any }>()
);

export const setScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation API',
    props<{ contractId: number; note: string }>()
);

export const setScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const setScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Fail',
    props<{ error: any }>()
);

export const removeScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION] Remove Schedule Orientation API',
    props<{ contractId: number }>()
);

export const removeScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION] Remove Schedule Orientation Success'
);

export const removeScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION] Remove Schedule Orientation Fail',
    props<{ error: any }>()
);

export const resetFacilityScheduleOrientationPermission = createAction(
    '[COMPLIANCE REPORT COMPONENT] Reset Schedule Orientation Permission'
);

export const loadFacilityScheduleOrientationPermission = createAction(
    '[SCHEDULE ORIENTATION] Facility Schedule Orientation Permission API',
    props<{ facilityId: number }>()
);

export const loadFacilityScheduleOrientationPermissionSuccess = createAction(
    '[SCHEDULE ORIENTATION] Facility Schedule Orientation Permission Success',
    props<{ orientationPermissionId: number }>()
);

export const loadFacilityScheduleOrientationPermissionFail = createAction(
    '[SCHEDULE ORIENTATION] Facility Schedule Orientation Permission Fail',
    props<{ error: any }>()
);

export const saveNewOrientation = createAction(
    '[SCHEDULE ORIENTATION COMPONENT API] Add New Orientation',
    props<{ contractId: number; newOrientation: AddOrientationSession[]; args: FetchArgs; showInMayAya: boolean }>()
);

export const saveNewOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION] Add New Orientation Success',
    props<{ contractId: number; args: FetchArgs; showInMayAya: boolean }>()
);

export const saveNewOrientationFail = createAction(
    '[SCHEDULE ORIENTATION] Add New Orientation Fail',
    props<{ error: any }>()
);

export const cancelScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION CANCEL] Cancel Schedule Orientation API',
    props<{ scheduleOrientationId: number }>()
);

export const cancelScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION CANCEL] Cancel Schedule Orientation Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const cancelScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION CANCEL] Cancel Schedule Orientation Fail',
    props<{ error: any }>()
);

export const setScheduleOrientationSessionDateForCandidateSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Set Schedule Orientation Date For Candidate Success with Sessions',
    props<{ scheduleOrientation: ScheduleOrientation; contractId: number }>()
);

export const addScheduleOrientationSessionDateForCandidateSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Add Schedule Orientation Date For Candidate Success',
    props<{ scheduleOrientation: ScheduleOrientation; contractId: number }>()
);

export const setScheduleOrientationSessionDateForCandidateFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Set Schedule Orientation Date For Candidate Fail with Sessions',
    props<{ error: any }>()
);

export const addScheduleOrientationSessionDateForCandidateFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Add Schedule Orientation Date For Candidate Fail',
    props<{ error: any }>()
);

export const setRescheduleScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule  Orientation API',
    props<{ scheduleOrientationId: number }>()
);

export const setRescheduleScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule  Orientation API Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const setRescheduleScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule  Orientation API Fail',
    props<{ error: any }>()
);

export const setAskForNewAvailabilityScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION SESSION] Ask For New Availability  Orientation API',
    props<{ scheduleOrientationId: number }>()
);

export const setAskForNewAvailabilityScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Ask For New Availability Orientation API Success',
    props<{ scheduleOrientation: ScheduleOrientation; contractId: number }>()
);

export const setAskForNewAvailabilityScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Ask For New Availability Orientation API Fail',
    props<{ error: any }>()
);

export const setNoteScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Orientation API',
    props<{ scheduleOrientationId: number; note: string }>()
);

export const setNoteScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Orientation API Success',
    props<{ scheduleOrientationId: number; note: string }>()
);

export const setNoteScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Orientation API Fail',
    props<{ error: any }>()
);

export const setSendToMyAyaScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send To My Aya Orientation API',
    props<{ scheduleOrientationId: number }>()
);

export const setSendToMyAyaScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send To My Aya Orientation API Success',
    props<{ scheduleOrientation: ScheduleOrientation; contractId: number }>()
);

export const setSendToMyAyaScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send To My Aya Orientation API Fail',
    props<{ error: any }>()
);

export const rescheduleOrientationDateSuccessCompleted = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule Orientation Date Success Completed'
);

export const loadSessionsNextDay = createAction(
    '[SCHEDULE ORIENTATION] Load Sessions Next Day API',
    props<{ contractId: number; sessionTypeId: number }>()
);

export const loadSessionsNextDaySuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Sessions Next Day Success',
    props<{ day: number }>()
);

export const loadSessionsNextDayFail = createAction(
    '[SCHEDULE ORIENTATION] Load Sessions Next Day Fail',
    props<{ error: any }>()
);

export const loadDoesAnyOrientationExist = createAction(
    '[SCHEDULE ORIENTATION] Load DoesAnyOrientationExist Day API',
    props<{ contractId: number }>()
);

export const loadDoesAnyOrientationExistSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load DoesAnyOrientationExist Success',
    props<{ result: boolean }>()
);

export const loadDoesAnyOrientationExistFail = createAction(
    '[SCHEDULE ORIENTATION] Load DoesAnyOrientationExist Fail',
    props<{ error: any }>()
);

export const loadMultiBundlesStatuses = createAction(
    '[SCHEDULE ORIENTATION] Load Multi Bundles Statuses API',
    props<{ contractId: number }>()
);

export const loadMultiBundlesStatusesSuccess = createAction(
    '[SCHEDULE ORIENTATION] Load Multi Bundles Statuses Success',
    props<{ multiBundleStatuses: MultiBundleStatus[] }>()
);

export const loadMultiBundlesStatusesFail = createAction(
    '[SCHEDULE ORIENTATION] Load Multi Bundles Statuses Fail',
    props<{ error: any }>()
);

export const updateScheduleOrientationAvailability = createAction(
    '[SCHEDULE ORIENTATION] Update Schedule Orientation Availability',
    props<{ updateOrientationDay: UpdateOrientationDay }>()
);

export const updateScheduleOrientationAvailabilitySuccess = createAction(
    '[SCHEDULE ORIENTATION] Update Schedule Orientation Availability Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const updateScheduleOrientationAvailabilityFail = createAction(
    '[SCHEDULE ORIENTATION] Update Schedule Orientation Availability Fail',
    props<{ error: any }>()
);

export const setScheduleOrientationMultiDayForCandidate = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Multi Day For Candidate',
    props<{ firstDayOrientationId: number; candidateAvailabilityDateArray: CandidateAvailabilityDate[] }>()
);

export const setScheduleOrientationMultiDayForCandidateSuccess = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Multi Day For Candidate Success',
    props<{ scheduleOrientations: ScheduleOrientation }>()
);

export const setScheduleOrientationMultiDayForCandidateFail = createAction(
    '[SCHEDULE ORIENTATION] Set Schedule Orientation Multi Day For Candidate Fail',
    props<{ error: any }>()
);

export const multiDayAskForNewAvailabilityDates = createAction(
    '[SCHEDULE ORIENTATION] Multi Day Ask For New Availability Dates',
    props<{ firstDayOrientationId: number; updateOrientationDays: UpdateOrientationDay[] }>()
);

export const multiDayAskForNewAvailabilityDatesSuccess = createAction(
    '[SCHEDULE ORIENTATION] Multi Day Ask For New Availability Dates Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const multiDayAskForNewAvailabilityDatesFail = createAction(
    '[SCHEDULE ORIENTATION] Multi Day Ask For New Availability Dates Fail',
    props<{ error: any }>()
);

export const updatePresetDatesOfScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION] Update Preset Dates Of Schedule Orientation',
    props<{ presetDateDto: ScheduleOrientationPresetDate }>()
);

export const updatePresetDatesOfScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION] Update Preset Dates Of Schedule Orientation Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const updatePresetDatesOfScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION] Update Preset Dates Of Schedule Orientation Fail',
    props<{ error: any }>()
);

export const updateNoteOfScheduleOrientation = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Of Schedule Orientation',
    props<{ scheduleOrientationId: number; note: string }>()
);

export const updateNoteOfScheduleOrientationSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Of Schedule Orientation Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const updateNoteOfScheduleOrientationFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Update Note Of Schedule Orientation Fail',
    props<{ error: any }>()
);

export const rescheduleMultiDayOrientations = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule Multi Day Orientations',
    props<{ firstDayOrientationId: number; orientationIds: number[] }>()
);

export const rescheduleMultiDayOrientationsSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule Multi Day Orientations Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const rescheduleMultiDayOrientationsFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Reschedule Multi Day Orientations Fail',
    props<{ error: any }>()
);

export const sendMultiDayOrientationToMyAya = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send Multi Day Orientation To MyAya',
    props<{ firstDayOrientationId: number; orientationIds: number[] }>()
);

export const sendMultiDayOrientationToMyAyaSuccess = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send Multi Day Orientation To MyAya Success',
    props<{ scheduleOrientation: ScheduleOrientation }>()
);

export const sendMultiDayOrientationToMyAyaFail = createAction(
    '[SCHEDULE ORIENTATION SESSION] Send Multi Day Orientation To MyAya Fail',
    props<{ error: any }>()
);
